import React,
{
    useCallback,
    useEffect,
    useRef,
    useState
}
    from 'react';import {navigate}
    from './Router';
import masterVolume from './masterVolume';
import {createPreloadedAudio}
    from './audioPreload';
import {isHalloweenMode}
    from './seasonalMode';
import RGLIcon from './RGLIcon';

const ABOUT_ME_TAB_STORAGE_KEY = 'aw24-aboutme-active-tab';
const HALLOWEEN_MODE = isHalloweenMode();
const ABOUT_ME_AUDIO_FADE_OUT_MS = 140;
const ABOUT_ME_TRANSITION_MIN_CLOSE_MS = 500;
const ABOUT_ME_TRANSITION_MIN_OPEN_MS = 320;
const ABOUT_ME_PAGE_LEAVE_MS = 460;
const ABOUT_ME_GENERAL_TILE_SIZE = 248;
const ABOUT_ME_OFFLINE_WALKER_BPM = HALLOWEEN_MODE ? 168.784 : 170;
const ABOUT_ME_OFFLINE_WALKER_FRAME_INTERVAL_MS = 60000 / (ABOUT_ME_OFFLINE_WALKER_BPM * 2);
const ABOUT_ME_ONLINE_WALKER_FRAME_WIDTH = 323;
const ABOUT_ME_ONLINE_WALKER_FRAME_HEIGHT = 504;
const ABOUT_ME_ONLINE_WALKER_BASE_HEIGHT = 156;
const ABOUT_ME_ONLINE_WALKER_SPEED_PX_PER_SECOND = 90;
const ABOUT_ME_ONLINE_WALKER_FLOOR_OFFSET = 0;
const ABOUT_ME_ONLINE_WALKER_WALK_FRAME_INDICES = [0, 1, 2, 3];
const ABOUT_ME_ONLINE_WALKER_EXIT_FRAME_INDEX = 4;
const ABOUT_ME_ONLINE_WALKER_EXIT_JUMP_HEIGHT = 15;
const ABOUT_ME_ONLINE_WALKER_EXIT_FALL_DISTANCE = 260;
const ABOUT_ME_ONLINE_WALKER_EXIT_DURATION_MS = 1240;
const ABOUT_ME_ONLINE_WALKER_EXIT_ROTATION_DEG = 60;
const ABOUT_ME_STAGE_WIDTH = 1180;
const ABOUT_ME_STAGE_HEIGHT = 760;
const ABOUT_ME_STAGE_VIEWPORT_PADDING = 48;
const ABOUT_ME_STAGE_MOBILE_WIDTH_PADDING = 16;
const ABOUT_ME_STAGE_MOBILE_HEIGHT_PADDING = 24;
const ABOUT_ME_TAB_MIN_WIDTH = 112;
const ABOUT_ME_TAB_HEIGHT = 58;
const ABOUT_ME_TAB_ICON_SIZE = 100;
const ABOUT_ME_TAB_GAP = 10;
const ABOUT_ME_TAB_ROW_SIDE_PADDING = 16;

function readAboutMeViewportSize()
{
    if (typeof window === 'undefined')
    {
        return {
            width: 1440,
            height: 900
        };
    }

    return {
        width: Math.round(window.innerWidth),
        height: Math.round(window.innerHeight),
    };
}

function getAboutMeMusicSource(src)
{
    if (!HALLOWEEN_MODE || !src) return src;

    const extensionIndex = src.lastIndexOf('.');
    if (extensionIndex < 0) return `${src}-Halloween.ogg`;

    return `${src.slice(0, extensionIndex)}-Halloween.ogg`;
}

const ABOUT_ME_TAB_ICON_FILES = {
    general:
    {
        active: 'AM-Icon_General.png',
        activeHalloween: 'AM-Icon_General-Halloween.png',
        inactive: 'AM-Icon_GeneralUn.png',
        inactiveHalloween: 'AM-Icon_GeneralUn-Halloween.png',
    },
    offline:
    {
        active: 'AM-Icon_Offline.png',
        activeHalloween: 'AM-Icon_Offline-Halloween.png',
        inactive: 'AM-Icon_OfflineUn.png',
        inactiveHalloween: 'AM-Icon_OfflineUn-Halloween.png',
    },
    online:
    {
        active: 'AM-Icon_Online.png',
        inactive: 'AM-Icon_OnlineUn.png',
    },
    games:
    {
        active: 'AM-Icon_Games.png',
        inactive: 'AM-Icon_GamesUn.png',
    },
    secret:
    {
        active: 'AM-Icon_Scret.png',
        inactive: 'AM-Icon_ScretUn.png',
    },
};

function getAboutMeTabIconSource(sectionId, isActive)
{
    const iconConfig = ABOUT_ME_TAB_ICON_FILES[sectionId] || {};

    if (HALLOWEEN_MODE && sectionId === 'general')
    {
        return `/AboutMe Images/TabIcons/${isActive ? (iconConfig.activeHalloween || iconConfig.active) : (iconConfig.inactiveHalloween || iconConfig.inactive)}`;
    }

    if (HALLOWEEN_MODE && sectionId === 'offline')
    {
        return `/AboutMe Images/TabIcons/${isActive ? (iconConfig.activeHalloween || iconConfig.active) : (iconConfig.inactiveHalloween || iconConfig.inactive)}`;
    }

    return `/AboutMe Images/TabIcons/${isActive ? (iconConfig.active || iconConfig.inactive) : (iconConfig.inactive || iconConfig.active)}`;
}

function getNavigationType()
{
    try
    {
        const entries = typeof performance !== 'undefined' && typeof performance.getEntriesByType === 'function' ?
            performance.getEntriesByType('navigation') :
            [];
        if (entries && entries[0] && entries[0].type) return entries[0].type;
    }
    catch (e)
    {}

    try
    {
        if (typeof performance !== 'undefined' && performance.navigation)
        {
            if (performance.navigation.type === 1) return 'reload';
            if (performance.navigation.type === 0) return 'navigate';
        }
    }
    catch (e)
    {}

    return 'navigate';
}

const sections = [
{
    id: 'general',
    title: 'Bruj',
    pathLabel: 'GENERAL',
    eyebrow: 'What do I do',
    summary: 'A little bit about me',
    details: [
        'My name\'s Ariel, but you can call me Ari!\nI\'m a 22-year-old idiot who lives in California\'s constant enviromental disaster and studies Game Design in college. When I\'m not losing what is left of my sanity on college work, I make digital art and animations, occasionally for mediocre games I help make alongside with friends.',
        'If want to check out my work, you should pass by the Projects tab on the main page!\n\n',
        'Surprise surprise, I am a furry! I know big scary news RAHHHH!! My OC is a wolf whos also part hellhound, look i know the colors and the look on the art kinda makes it hard to see like a wolf but he is. His name is Ari LMAO, its kinda strange cuz youd normally have a name for your OC, right? Well i dont want another name for people to refer me as so i just went with my own name. So works for me not having to remember a different name i have to react to.',
    ],
},
{
    id: 'offline',
    title: 'Conventions n shit',
    pathLabel: 'OFFLINE',
    eyebrow: 'In Life',
    summary: 'I touch grass sometimes, i swear.',
    details: [
        'Let me make it clear that im only going to talk about events i go to from time to time, and no i wont tell you where i live you fucking weirdo',
        '',
        'Alot of the time i like to go to furry conventions and meet up with my friends, i dont do this often but its always amazing to go around different places in the US and burn money on furry shit. For now Further Confusion is one i go to yearly but ive been wanting to go to different cons, even non furry related ones.',
        'Like: Further Confusion, Anthro SoCal, Anthrocon, Comic-Con, Game Dev Conference, PAX, and other cons.',
        'Aside from conventions, i just like to hang out with my friends and explore new places.',
    ],
},
{
    id: 'online',
    title: 'The only alias you need to know',
    pathLabel: 'ONLINE',
    eyebrow: 'Presence',
    summary: 'All my friends are in my computer!',
    details: [
        'I use alot of accounts online but if you want to find me, the easiest way is to look for my discord account (check the discord tab on the main page)',
        'HOWEVER, if you want to find me on other platforms, i have a few social media accounts that i use and they all go under the same handle \'@arielwolf24\'',
        '\nSome of the platforms i use are: Twitter, Reddit, Instagram, and YouTube. I also have a Twitch account but i dont stream often so its not really worth mentioning. Mostly competitive TF2. I dont use places like like tiktok, so uf you see an account on the most random place then its probably me but just to claim my own handle.',
        'Funnily enough, Roblox is the only place i locked myself out of my proper handle, so i have a different handle there. I dont play often there but if you want to find me there, its \'@ariel_wolf24\'',
    ],
},
{
    id: 'games',
    title: 'Games',
    pathLabel: 'GAMES',
    eyebrow: 'Stuff I Play',
    summary: 'Welcome to the Baroness',
    details: [
        'Itll have favorite games, server history, classes, mains, or anything tied to steam games i frequent.',
        'theres gonna be weird shit',
        'place holder yada yada AUUUR',
    ],
},
{
    id: 'secret',
    title: 'Secret',
    pathLabel: 'HIDDEN',
    eyebrow: 'Hidden',
    summary: 'Snooping around, are ya?',
    details: [
        'This tab only peeks out while Left Shift is being held.',
        'It is a temporary secret area for whatever hidden junk gets added later.',
        'Release the key and this tab goes away again.',
    ],
}, ];

const ABOUT_ME_TAB_PALETTES = {
    general:
    {
        pageText: '#e7e2f6',
        tabActiveTop: 'rgb(0, 82, 130)',
        tabActiveBottom: 'rgb(0, 132, 208)',
        tabInactiveTop: 'rgba(0, 76, 120, 0.84)',
        tabInactiveBottom: 'rgba(72, 38, 138, 0.88)',
        tabActiveBorderBottom: 'rgb(92, 63, 173)',
        panelTop: 'rgb(23, 146, 240)',
        panelBottom: 'rgb(255, 0, 234)',
        accent: '#f1dcff',
        title: '#f8f2ff',
        summary: 'rgba(245,236,255,0.9)',
        card: 'rgba(255,255,255,0.1)',
        cardBorder: 'rgba(242,230,255,0.2)',
        aside: 'rgba(0,0,0,0.28)',
        noteAccent: '#edd7ff',
        overlayInner: 'rgb(98, 179, 255)',
        overlayMid: 'rgb(0, 81, 255)',
        overlayOuter: 'rgb(236, 0, 217)',
    },
    offline:
    {
        pageText: '#fff1ef',
        tabActiveTop: 'rgb(149,45,45)',
        tabActiveBottom: 'rgb(57,12,18)',
        tabInactiveTop: 'rgba(105,39,44,0.8)',
        tabInactiveBottom: 'rgba(46,14,19,0.88)',
        tabActiveBorderBottom: 'rgb(57,12,18)',
        panelTop: 'rgba(48,9,16,0.97)',
        panelBottom: 'rgba(113,24,31,0.93)',
        accent: '#ffaba2',
        title: '#fff2ef',
        summary: 'rgba(255,241,239,0.84)',
        card: 'rgba(255,255,255,0.06)',
        cardBorder: 'rgba(255,214,214,0.16)',
        aside: 'rgba(18,0,0,0.28)',
        noteAccent: '#ffbeb7',
        overlayInner: 'rgb(169,55,55)',
        overlayMid: 'rgb(73,16,25)',
        overlayOuter: 'rgb(20,3,7)',
    },
    online:
    {
        pageText: '#eef3ff',
        tabActiveTop: 'rgb(88,101,242)',
        tabActiveBottom: 'rgb(35,39,42)',
        tabInactiveTop: 'rgba(74,83,138,0.82)',
        tabInactiveBottom: 'rgba(34,38,47,0.9)',
        tabActiveBorderBottom: 'rgb(35,39,42)',
        panelTop: 'rgba(27,30,36,0.97)',
        panelBottom: '#5865F2',
        accent: '#b8c1ff',
        title: '#f4f6ff',
        summary: 'rgba(238,243,255,0.84)',
        card: 'rgba(255,255,255,0.06)',
        cardBorder: 'rgba(204,214,255,0.14)',
        aside: 'rgba(17,19,24,0.28)',
        noteAccent: '#c9d0ff',
        overlayInner: '#5865F2',
        overlayMid: '#313684',
        overlayOuter: '#000000',
    },
    games:
    {
        pageText: '#e7f0fb',
        tabActiveTop: 'rgb(42,71,94)',
        tabActiveBottom: 'rgb(23,26,33)',
        tabInactiveTop: 'rgba(44,64,84,0.82)',
        tabInactiveBottom: 'rgba(23,28,37,0.9)',
        tabActiveBorderBottom: 'rgb(23,26,33)',
        panelTop: 'rgba(18,26,36,0.97)',
        panelBottom: 'rgba(42,71,94,0.93)',
        accent: '#9cc7ef',
        title: '#eef6ff',
        summary: 'rgba(231,240,251,0.84)',
        card: 'rgba(255,255,255,0.05)',
        cardBorder: 'rgba(196,227,255,0.14)',
        aside: 'rgba(8,14,20,0.3)',
        noteAccent: '#abd3f7',
        overlayInner: 'rgb(66,105,140)',
        overlayMid: 'rgb(26,43,59)',
        overlayOuter: 'rgb(7,11,17)',
    },
    secret:
    {
        pageText: '#f4eaf7',
        tabActiveTop: 'rgb(90, 24, 93)',
        tabActiveBottom: 'rgb(24, 7, 31)',
        tabInactiveTop: 'rgba(77, 26, 79, 0.82)',
        tabInactiveBottom: 'rgba(27, 10, 34, 0.9)',
        tabActiveBorderBottom: 'rgb(24, 7, 31)',
        panelTop: 'rgba(35, 11, 43, 0.97)',
        panelBottom: 'rgba(92, 28, 108, 0.93)',
        accent: '#f0b8ff',
        title: '#fff2ff',
        summary: 'rgba(250,234,255,0.84)',
        card: 'rgba(255,255,255,0.06)',
        cardBorder: 'rgba(244, 195, 255, 0.14)',
        aside: 'rgba(10, 0, 14, 0.3)',
        noteAccent: '#f2c6ff',
        overlayInner: 'rgb(139, 48, 160)',
        overlayMid: 'rgb(58, 14, 69)',
        overlayOuter: 'rgb(10, 4, 14)',
    },
};

const ABOUT_ME_TAB_TRANSITION_IMAGES = {
    general:
    {
        src: '/AboutMe Images/General.png',
        width: 'min(46vw, 600px)',
    },
    offline:
    {
        src: '/AboutMe Images/Offline.png',
        width: 'min(41vw, 530px)',
    },
    online:
    {
        src: '/AboutMe Images/Online.png',
        width: 'min(49vw, 840px)',
    },
    games:
    {
        src: '/AboutMe Images/Games.png',
        width: 'min(33vw, 410px)',
    },
    secret:
    {
        src: '/AboutMe Images/Secret.png',
        width: 'min(49vw, 540px)',
    },
};

const ABOUT_ME_BACKGROUND_IMAGE_SOURCES = [
    '/AboutMe Images/GeneralBG-Tiles.png',
    '/AboutMe Images/GeneralBG-Tiles_Tint.png',
];

const ABOUT_ME_HALLOWEEN_GENERAL_PALETTE = {
    pageText: '#e7e2f6',
    tabActiveTop: 'rgb(130, 0, 0)',
    tabActiveBottom: 'rgb(208, 0, 0)',
    tabInactiveTop: 'rgba(120, 0, 0, 0.84)',
    tabInactiveBottom: 'rgba(138, 38, 96, 0.88)',
    tabActiveBorderBottom: 'rgb(85, 5, 25)',
    panelTop: '#181717',
    panelBottom: '#CC0000',
    accent: '#f1dcff',
    title: '#f8f2ff',
    summary: 'rgba(245,236,255,0.9)',
    card: 'rgba(255,255,255,0.1)',
    cardBorder: 'rgba(242,230,255,0.2)',
    aside: 'rgba(0,0,0,0.28)',
    noteAccent: '#edd7ff',
    overlayInner: '#cc0b7c',
    overlayMid: '#420720',
    overlayOuter: '#460101',
};

const ABOUT_ME_GENERAL_BACKGROUND_THEMES = {
    normal:
    {
        baseBackground: 'linear-gradient(135deg, rgb(20, 72, 150) 0%, rgb(73, 36, 164) 52%, rgb(145, 20, 196) 100%)',
        tileImage: "url('/AboutMe Images/GeneralBG-Tiles.png')",
    },
    halloween:
    {
        baseBackground: 'linear-gradient(135deg, rgb(184, 0, 0) 0%, rgb(0, 0, 0) 52%, rgb(197, 0, 59) 100%)',
        tileImage: "url('/AboutMe Images/GeneralBG-Tiles.png')",
        tileFilter: 'brightness(1.12) saturate(1.18)',
        tintColor: 'rgba(255, 255, 255, 0.5)',
        tintMaskImage: "url('/AboutMe Images/GeneralBG-Tiles_Tint.png')",
    },
};

function getAboutMePalette(sectionId)
{
    const basePalette = ABOUT_ME_TAB_PALETTES[sectionId] || ABOUT_ME_TAB_PALETTES.general;

    if (HALLOWEEN_MODE && sectionId === 'general')
    {
        return {
            ...basePalette,
            ...ABOUT_ME_HALLOWEEN_GENERAL_PALETTE,
        };
    }

    return basePalette;
}

export default function AboutMe()
{
    const [visible, setVisible] = useState(false);
    const [activeSectionId, setActiveSectionId] = useState(() =>
    {
        const navigationType = getNavigationType();

        if (navigationType !== 'reload') return sections[0].id;

        try
        {
            const savedSectionId = localStorage.getItem(ABOUT_ME_TAB_STORAGE_KEY);
            return sections.some((section) => section.id === savedSectionId) ? savedSectionId : sections[0].id;
        }
        catch (e)
        {
            return sections[0].id;
        }
    });
    const [displayedSectionId, setDisplayedSectionId] = useState(() =>
    {
        const navigationType = getNavigationType();

        if (navigationType !== 'reload') return sections[0].id;

        try
        {
            const savedSectionId = localStorage.getItem(ABOUT_ME_TAB_STORAGE_KEY);
            return sections.some((section) => section.id === savedSectionId) ? savedSectionId : sections[0].id;
        }
        catch (e)
        {
            return sections[0].id;
        }
    });
    const [audioConfig, setAudioConfig] = useState(
    {
        default:
        {},
        tabs:
        {}
    });
    const [audioAssetsReady, setAudioAssetsReady] = useState(false);
    const [imageAssetsReady, setImageAssetsReady] = useState(false);
    const [audioReplayKey, setAudioReplayKey] = useState(0);
    const [pageLeaving, setPageLeaving] = useState(false);
    const [leftShiftHeld, setLeftShiftHeld] = useState(false);
    const [onlineWalkerDisabled, setOnlineWalkerDisabled] = useState(false);
    const [onlineWalkerExitState, setOnlineWalkerExitState] = useState(
    {
        active: false,
        offsetY: 0,
        rotationDeg: 0,
    });
    const [onlineWalkerExitToken, setOnlineWalkerExitToken] = useState(0);
    const [onlineWalkerLeft, setOnlineWalkerLeft] = useState(() => -Math.round(ABOUT_ME_ONLINE_WALKER_BASE_HEIGHT * (ABOUT_ME_ONLINE_WALKER_FRAME_WIDTH / ABOUT_ME_ONLINE_WALKER_FRAME_HEIGHT)));
    const [onlineWalkerViewportWidth, setOnlineWalkerViewportWidth] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1440));
    const [onlineWalkerHeight, setOnlineWalkerHeight] = useState(() => ABOUT_ME_ONLINE_WALKER_BASE_HEIGHT);
    const [viewportSize, setViewportSize] = useState(() => readAboutMeViewportSize());
    const [backgroundLayersVisible, setBackgroundLayersVisible] = useState(() => !Boolean(window.__aw24AboutMeEntryTransition && window.__aw24AboutMeEntryTransition.enabled));
    const [tabTransition, setTabTransition] = useState(
    {
        active: false,
        radiusVmax: 0,
        opacity: 1,
        imageScale: 0.16,
        imageOpacity: 1,
        imageRotateDeg: -8,
        imageWidth: 'min(34vw, 420px)',
        imageSrc: '',
        durationMs: ABOUT_ME_TRANSITION_MIN_CLOSE_MS,
        closeDurationMs: ABOUT_ME_TRANSITION_MIN_CLOSE_MS,
        openDurationMs: ABOUT_ME_TRANSITION_MIN_OPEN_MS,
    });

    const backgroundAudioRef = useRef(null);
    const startDelayTimerRef = useRef(null);
    const shouldPlaySfxOnNextBackgroundStartRef = useRef(true);
    const transitionTimersRef = useRef([]);
    const hasPlayedEntryTransitionRef = useRef(false);
    const pageLeaveTimerRef = useRef(null);
    const lastNonSecretSectionRef = useRef('general');

    const activeSection = sections.find((section) => section.id === activeSectionId) || sections[0];
    const displayedSection = sections.find((section) => section.id === displayedSectionId) || sections[0];
    const visibleSections = sections.filter((section) => section.id !== 'secret' || leftShiftHeld);
    const displayedPalette = getAboutMePalette(displayedSection.id);
    const transitionPalette = getAboutMePalette(activeSection.id);
    const generalBackgroundTheme = ABOUT_ME_GENERAL_BACKGROUND_THEMES[HALLOWEEN_MODE ? 'halloween' : 'normal'] || ABOUT_ME_GENERAL_BACKGROUND_THEMES.normal;
    const aboutMeAssetsReady = audioAssetsReady && imageAssetsReady;
    const displayedSectionPathLabel = displayedSection.pathLabel || displayedSection.title.toUpperCase();
    const onlineWalkerWidth = Math.round(onlineWalkerHeight * (ABOUT_ME_ONLINE_WALKER_FRAME_WIDTH / ABOUT_ME_ONLINE_WALKER_FRAME_HEIGHT));
    const onlineWalkerFrameIndices = onlineWalkerExitState.active ? [ABOUT_ME_ONLINE_WALKER_EXIT_FRAME_INDEX] : ABOUT_ME_ONLINE_WALKER_WALK_FRAME_INDICES;
    const shouldShowOnlineWalker = displayedSection.id === 'offline' && !onlineWalkerDisabled;
    const isCoarsePointer = typeof window !== 'undefined' && window.matchMedia ?
        window.matchMedia('(pointer: coarse)').matches :
        false;
    const aboutMeStageWidthPadding = isCoarsePointer ? ABOUT_ME_STAGE_MOBILE_WIDTH_PADDING : ABOUT_ME_STAGE_VIEWPORT_PADDING;
    const aboutMeStageHeightPadding = isCoarsePointer ? ABOUT_ME_STAGE_MOBILE_HEIGHT_PADDING : ABOUT_ME_STAGE_VIEWPORT_PADDING;
    const aboutMeTabRowMinWidth = (visibleSections.length * ABOUT_ME_TAB_MIN_WIDTH) +
        (Math.max(0, visibleSections.length - 1) * ABOUT_ME_TAB_GAP) +
        (ABOUT_ME_TAB_ROW_SIDE_PADDING * 2);
    const aboutMeStageWidth = Math.max(ABOUT_ME_STAGE_WIDTH, aboutMeTabRowMinWidth);
    const aboutMeStageScale = Math.min(
        1,
        Math.max(0.1, (viewportSize.width - aboutMeStageWidthPadding) / aboutMeStageWidth),
        Math.max(0.1, (viewportSize.height - aboutMeStageHeightPadding) / ABOUT_ME_STAGE_HEIGHT)
    );
    const getOfflineWalkerSyncTimeMs = useCallback(() =>
    {
        const audio = backgroundAudioRef.current;
        if (!audio || !Number.isFinite(audio.currentTime) || audio.paused) return null;
        return Math.max(0, audio.currentTime * 1000);
    }, []);

    const clearPendingAudioStart = useCallback(() =>
    {
        if (startDelayTimerRef.current)
        {
            clearTimeout(startDelayTimerRef.current);
            startDelayTimerRef.current = null;
        }
    }, []);

    const clearTransitionTimers = useCallback(() =>
    {
        transitionTimersRef.current.forEach((timerId) => clearTimeout(timerId));
        transitionTimersRef.current = [];
    }, []);

    const clearPageLeaveTimer = useCallback(() =>
    {
        if (pageLeaveTimerRef.current)
        {
            clearTimeout(pageLeaveTimerRef.current);
            pageLeaveTimerRef.current = null;
        }
    }, []);

    const getTransitionTimings = useCallback((playDelayMs) =>
    {
        const safePlayDelayMs = Number.isFinite(playDelayMs) ? playDelayMs : 0;
        const closeDurationMs = Math.max(
            ABOUT_ME_TRANSITION_MIN_CLOSE_MS,
            Math.min(900, Math.round(safePlayDelayMs * 0.9) || ABOUT_ME_TRANSITION_MIN_CLOSE_MS)
        );
        const revealDelayMs = Math.max(closeDurationMs + 40, safePlayDelayMs);
        const openDurationMs = Math.max(
            ABOUT_ME_TRANSITION_MIN_OPEN_MS,
            Math.min(620, Math.round(revealDelayMs * 0.48) || ABOUT_ME_TRANSITION_MIN_OPEN_MS)
        );

        return {
            closeDurationMs,
            revealDelayMs,
            openDurationMs
        };
    }, []);

    const startTabTransition = useCallback((playDelayMs, nextSectionId) =>
    {
        clearTransitionTimers();

        const
        {
            closeDurationMs,
            revealDelayMs,
            openDurationMs
        } = getTransitionTimings(playDelayMs);
        const transitionSectionId = nextSectionId || activeSectionId;
        const imageConfig = ABOUT_ME_TAB_TRANSITION_IMAGES[transitionSectionId] || ABOUT_ME_TAB_TRANSITION_IMAGES.general;

        setTabTransition(
        {
            active: true,
            radiusVmax: 0,
            opacity: 1,
            imageScale: 0.16,
            imageOpacity: 1,
            imageRotateDeg: -8,
            imageWidth: imageConfig.width,
            imageSrc: imageConfig.src,
            durationMs: closeDurationMs,
            closeDurationMs,
            openDurationMs,
        });

        requestAnimationFrame(() =>
        {
            setTabTransition((current) => (
            {
                ...current,
                radiusVmax: 160,
                imageScale: 1,
                imageOpacity: 1,
                imageRotateDeg: -3,
                durationMs: closeDurationMs,
            }));
        });

        transitionTimersRef.current.push(setTimeout(() =>
        {
            if (nextSectionId) setDisplayedSectionId(nextSectionId);
        }, closeDurationMs));

        transitionTimersRef.current.push(setTimeout(() =>
        {
            requestAnimationFrame(() =>
            {
                setTabTransition((current) => (
                {
                    ...current,
                    radiusVmax: 160,
                    opacity: 0,
                    imageOpacity: 0,
                    durationMs: openDurationMs,
                }));
            });
        }, revealDelayMs));

        transitionTimersRef.current.push(setTimeout(() =>
        {
            setTabTransition((current) => (
            {
                ...current,
                active: false,
                radiusVmax: 0,
                opacity: 1,
                imageScale: 0.16,
                imageOpacity: 1,
                imageRotateDeg: -8,
                imageWidth: 'min(34vw, 420px)',
                imageSrc: '',
                durationMs: ABOUT_ME_TRANSITION_MIN_CLOSE_MS,
                closeDurationMs: ABOUT_ME_TRANSITION_MIN_CLOSE_MS,
                openDurationMs: ABOUT_ME_TRANSITION_MIN_OPEN_MS,
            }));
        }, revealDelayMs + openDurationMs + 40));
    }, [activeSectionId, clearTransitionTimers, getTransitionTimings]);

    const stopBackgroundAudio = useCallback((fadeOutMs = ABOUT_ME_AUDIO_FADE_OUT_MS) =>
    {
        clearPendingAudioStart();

        if (!backgroundAudioRef.current) return;

        const audio = backgroundAudioRef.current;
        backgroundAudioRef.current = null;

        try
        {
            if (audio._aboutMeFadeRaf) cancelAnimationFrame(audio._aboutMeFadeRaf);
        }
        catch (e)
        {}

        const cleanupAudio = () =>
        {
            try
            {
                if (audio._aboutMeFadeRaf) cancelAnimationFrame(audio._aboutMeFadeRaf);
            }
            catch (e)
            {}
            try
            {
                audio.pause();
            }
            catch (e)
            {}
            try
            {
                audio.currentTime = 0;
            }
            catch (e)
            {}
            try
            {
                if (typeof audio._masterVolumeUnsub === 'function') audio._masterVolumeUnsub();
            }
            catch (e)
            {}
            try
            {
                if (typeof audio.removeAttribute === 'function') audio.removeAttribute('src');
            }
            catch (e)
            {}
            try
            {
                audio.srcObject = null;
            }
            catch (e)
            {}
            try
            {
                audio._aboutMeFadeRaf = null;
            }
            catch (e)
            {}
        };

        if (!Number.isFinite(fadeOutMs) || fadeOutMs <= 0)
        {
            cleanupAudio();
            return;
        }

        const startingVolume = Number.isFinite(audio.volume) ? audio.volume : 0;
        const startTime = performance.now();
        const step = (now) =>
        {
            const progress = Math.min(1, (now - startTime) / fadeOutMs);
            try
            {
                audio.volume = Math.max(0, startingVolume * (1 - progress));
            }
            catch (e)
            {}

            if (progress < 1)
            {
                audio._aboutMeFadeRaf = requestAnimationFrame(step);
                return;
            }

            cleanupAudio();
        };

        audio._aboutMeFadeRaf = requestAnimationFrame(step);
    }, [clearPendingAudioStart]);

    const getTabAudioConfig = useCallback((sectionId) =>
    {
        const defaults = audioConfig && audioConfig.default ? audioConfig.default :
        {};
        const tabConfig = audioConfig && audioConfig.tabs && audioConfig.tabs[sectionId] ? audioConfig.tabs[sectionId] :
        {};
        const halloweenBaseVolumes = {
            offline: 0.6,
            online: 0.8,
            games: 0.85,
        };
        return {
            ...defaults,
            ...tabConfig,
            ...(HALLOWEEN_MODE && Number.isFinite(halloweenBaseVolumes[sectionId]) ?
                {
                    baseVolume: halloweenBaseVolumes[sectionId]
                } : {})
        };
    }, [audioConfig]);

    const playClickSound = useCallback((sectionId) =>
    {
        const config = getTabAudioConfig(sectionId);
        if (!config.clickSfx) return;

        try
        {
            const sfx = new Audio(config.clickSfx);
            const clickVolume = Number.isFinite(Number(config.clickVolume)) ? Number(config.clickVolume) : 1;
            try
            {
                sfx.preload = 'auto';
            }
            catch (e)
            {}
            try
            {
                sfx.load();
            }
            catch (e)
            {}
            sfx._baseVolume = Math.max(0, Math.min(1, clickVolume));
            try
            {
                masterVolume.applyToElement(sfx);
            }
            catch (e)
            {}
            try
            {
                sfx.currentTime = 0;
            }
            catch (e)
            {}
            try
            {
                sfx.play().catch(() =>
                {});
            }
            catch (e)
            {}
        }
        catch (e)
        {}
    }, [getTabAudioConfig]);

    const preloadAudioSource = useCallback((src) =>
    {
        if (!src) return Promise.resolve();

        try
        {
            if (!window.__aw24AboutMePreloadedAudio) window.__aw24AboutMePreloadedAudio = {};

            const cached = window.__aw24AboutMePreloadedAudio[src];
            const audio = cached || createPreloadedAudio(src,
            {
                baseVolume: 1,
                loop: false,
                applyMaster: false,
            });
            if (!audio) return Promise.resolve();
            if (!cached) window.__aw24AboutMePreloadedAudio[src] = audio;

            if (audio.readyState >= 3) return Promise.resolve();

            return new Promise((resolve) =>
            {
                let settled = false;
                const finish = () =>
                {
                    if (settled) return;
                    settled = true;
                    try
                    {
                        audio.removeEventListener('canplaythrough', onReady);
                    }
                    catch (e)
                    {}
                    try
                    {
                        audio.removeEventListener('loadeddata', onReady);
                    }
                    catch (e)
                    {}
                    try
                    {
                        audio.removeEventListener('error', onError);
                    }
                    catch (e)
                    {}
                    resolve();
                };
                const onReady = () => finish();
                const onError = () => finish();

                try
                {
                    audio.addEventListener('canplaythrough', onReady,
                    {
                        once: true
                    });
                }
                catch (e)
                {}
                try
                {
                    audio.addEventListener('loadeddata', onReady,
                    {
                        once: true
                    });
                }
                catch (e)
                {}
                try
                {
                    audio.addEventListener('error', onError,
                    {
                        once: true
                    });
                }
                catch (e)
                {}
                try
                {
                    audio.load();
                }
                catch (e)
                {
                    finish();
                }
            });
        }
        catch (e)
        {
            return Promise.resolve();
        }
    }, []);

    const preloadAudioAssetsForConfig = useCallback(async (config) =>
    {
        try
        {
            const tabs = config && config.tabs && typeof config.tabs === 'object' ? Object.values(config.tabs) : [];
            const sources = Array.from(new Set(
                tabs.flatMap((tab) =>
                {
                    const audioSources = [];
                    if (tab && tab.music) audioSources.push(getAboutMeMusicSource(tab.music));
                    if (tab && tab.clickSfx) audioSources.push(tab.clickSfx);
                    return audioSources;
                }).filter(Boolean)
            ));

            await Promise.all(sources.map((src) => preloadAudioSource(src)));
        }
        catch (e)
        {}
    }, [preloadAudioSource]);

    const preloadImageSource = useCallback((src) =>
    {
        if (!src) return Promise.resolve();

        try
        {
            if (!window.__aw24AboutMePreloadedImages) window.__aw24AboutMePreloadedImages = {};

            const cached = window.__aw24AboutMePreloadedImages[src];
            const image = cached || new Image();
            if (!cached)
            {
                try
                {
                    image.decoding = 'async';
                }
                catch (e)
                {}
                window.__aw24AboutMePreloadedImages[src] = image;
            }

            if (image.complete && image.naturalWidth > 0) return Promise.resolve();

            return new Promise((resolve) =>
            {
                let settled = false;
                const finish = () =>
                {
                    if (settled) return;
                    settled = true;
                    try
                    {
                        image.removeEventListener('load', onReady);
                    }
                    catch (e)
                    {}
                    try
                    {
                        image.removeEventListener('error', onError);
                    }
                    catch (e)
                    {}
                    resolve();
                };
                const onReady = () => finish();
                const onError = () => finish();

                try
                {
                    image.addEventListener('load', onReady,
                    {
                        once: true
                    });
                }
                catch (e)
                {}
                try
                {
                    image.addEventListener('error', onError,
                    {
                        once: true
                    });
                }
                catch (e)
                {}
                image.src = src;
            });
        }
        catch (e)
        {
            return Promise.resolve();
        }
    }, []);

    const preloadImageAssets = useCallback(async () =>
    {
        try
        {
            const sources = Array.from(new Set([
                ...Object.values(ABOUT_ME_TAB_TRANSITION_IMAGES).map((entry) => entry && entry.src).filter(Boolean),
                ...ABOUT_ME_BACKGROUND_IMAGE_SOURCES,
            ]));

            await Promise.all(sources.map((src) => preloadImageSource(src)));
        }
        catch (e)
        {}
    }, [preloadImageSource]);

    useEffect(() =>
    {
        if (!aboutMeAssetsReady)
        {
            setVisible(false);
            return undefined;
        }

        const timer = setTimeout(() => setVisible(true), 35);
        return () => clearTimeout(timer);
    }, [aboutMeAssetsReady]);

    useEffect(() =>
    {
        if (!aboutMeAssetsReady || hasPlayedEntryTransitionRef.current) return undefined;

        const entryPayload = window.__aw24AboutMeEntryTransition;
        const from = (window.history && window.history.state && window.history.state.from) || null;
        const navigationType = getNavigationType();
        const shouldRunEntryTransition = Boolean(entryPayload && entryPayload.enabled) || (navigationType !== 'reload' && Boolean(from) && from !== '/AboutMe');

        if (!shouldRunEntryTransition)
        {
            hasPlayedEntryTransitionRef.current = true;
            return undefined;
        }

        const config = getTabAudioConfig(activeSectionId);
        const playDelayMs = Number.isFinite(Number(config.playDelayMs)) ? Math.max(0, Number(config.playDelayMs)) : 0;
        hasPlayedEntryTransitionRef.current = true;

        try
        {
            delete window.__aw24AboutMeEntryTransition;
        }
        catch (e)
        {}

        const timer = setTimeout(() =>
        {
            setBackgroundLayersVisible(true);
            startTabTransition(playDelayMs);
        }, 40);

        return () => clearTimeout(timer);
    }, [aboutMeAssetsReady, activeSectionId, getTabAudioConfig, startTabTransition]);

    useEffect(() =>
    {
        if (!sections.some((section) => section.id === activeSectionId))
        {
            setActiveSectionId(sections[0].id);
            setDisplayedSectionId(sections[0].id);
            return;
        }

        try
        {
            localStorage.setItem(ABOUT_ME_TAB_STORAGE_KEY, activeSectionId);
        }
        catch (e)
        {}
    }, [activeSectionId]);

    useEffect(() =>
    {
        let cancelled = false;

        const loadAudioConfig = async () =>
        {
            if (!cancelled) setAudioAssetsReady(false);
            if (!cancelled) setImageAssetsReady(false);

            const cachedConfig = window.__aw24AboutMeAudioConfig;
            if (!cancelled && cachedConfig && typeof cachedConfig === 'object')
            {
                setAudioConfig(
                {
                    default: cachedConfig.default ||
                    {},
                    tabs: cachedConfig.tabs ||
                    {},
                });
            }

            try
            {
                const data = await (async () =>
                {
                    const response = await fetch('/aboutMeAudio.json',
                    {
                        cache: 'no-store'
                    });
                    const result = await response.json();
                    try
                    {
                        window.__aw24AboutMeAudioConfig = result;
                    }
                    catch (e)
                    {}
                    return result;
                })();

                await Promise.all([
                    preloadAudioAssetsForConfig(data),
                    preloadImageAssets(),
                ]);

                if (!cancelled && data && typeof data === 'object')
                {
                    setAudioConfig(
                    {
                        default: data.default ||
                        {},
                        tabs: data.tabs ||
                        {},
                    });
                    setAudioAssetsReady(true);
                    setImageAssetsReady(true);
                }
            }
            catch (e)
            {
                if (!cancelled)
                {
                    setAudioConfig(
                    {
                        default:
                        {},
                        tabs:
                        {}
                    });
                    setAudioAssetsReady(true);
                    setImageAssetsReady(true);
                }
            }
        };

        loadAudioConfig();

        return () =>
        {
            cancelled = true;
        };
    }, [preloadAudioAssetsForConfig, preloadImageAssets]);

    useEffect(() =>
    {
        if (!audioAssetsReady) return undefined;

        stopBackgroundAudio();

        const config = getTabAudioConfig(activeSectionId);
        const musicSrc = getAboutMeMusicSource(config.music);
        if (!musicSrc) return undefined;

        const playDelayMs = Number.isFinite(Number(config.playDelayMs)) ? Math.max(0, Number(config.playDelayMs)) : 0;
        const baseVolume = Number.isFinite(Number(config.baseVolume)) ? Math.max(0, Math.min(1, Number(config.baseVolume))) : 0.5;
        const shouldLoop = typeof config.loop === 'boolean' ? config.loop : true;

        const shouldPlaySfxBeforeStart = shouldPlaySfxOnNextBackgroundStartRef.current;
        shouldPlaySfxOnNextBackgroundStartRef.current = true;

        if (shouldPlaySfxBeforeStart)
        {
            playClickSound(activeSectionId);
        }

        startDelayTimerRef.current = setTimeout(() =>
        {
            startDelayTimerRef.current = null;

            try
            {
                const preloadedAudioMap = window.__aw24AboutMePreloadedAudio ||
                {};
                const cachedAudio = preloadedAudioMap[musicSrc];
                const audio = cachedAudio && typeof cachedAudio.cloneNode === 'function' ?
                    cachedAudio.cloneNode(true) :
                    new Audio(musicSrc);
                audio.loop = shouldLoop;
                audio.preload = 'auto';
                audio._baseVolume = baseVolume;
                try
                {
                    audio.currentTime = 0;
                }
                catch (e)
                {}
                try
                {
                    masterVolume.applyToElement(audio);
                }
                catch (e)
                {}
                backgroundAudioRef.current = audio;
                try
                {
                    audio.play().catch(() =>
                    {});
                }
                catch (e)
                {}
            }
            catch (e)
            {}
        }, playDelayMs);

        return () => stopBackgroundAudio();
    }, [activeSectionId, audioAssetsReady, audioReplayKey, getTabAudioConfig, playClickSound, stopBackgroundAudio]);

    useEffect(() => () => stopBackgroundAudio(), [stopBackgroundAudio]);
    useEffect(() => () => clearTransitionTimers(), [clearTransitionTimers]);
    useEffect(() => () => clearPageLeaveTimer(), [clearPageLeaveTimer]);

    useEffect(() =>
    {
        const updateWalkerMetrics = () =>
        {
            const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1440;
            const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 900;
            const nextHeight = Math.round(Math.max(118, Math.min(176, viewportHeight * 0.2)));

            setOnlineWalkerViewportWidth(viewportWidth);
            setViewportSize((current) => (
                current.width === viewportWidth && current.height === viewportHeight ?
                current :
                {
                    width: viewportWidth,
                    height: viewportHeight
                }
            ));
            setOnlineWalkerHeight((current) => (current === nextHeight ? current : nextHeight));
        };

        updateWalkerMetrics();
        window.addEventListener('resize', updateWalkerMetrics);
        return () => window.removeEventListener('resize', updateWalkerMetrics);
    }, []);

    useEffect(() =>
    {
        if (!shouldShowOnlineWalker)
        {
            setOnlineWalkerLeft(-onlineWalkerWidth);
            return undefined;
        }

        let animationFrameId = null;
        let previousTimestamp = null;

        const animate = (timestamp) =>
        {
            if (previousTimestamp == null)
            {
                previousTimestamp = timestamp;
            }

            const elapsedMs = timestamp - previousTimestamp;
            previousTimestamp = timestamp;

            setOnlineWalkerLeft((current) =>
            {
                const next = current + ((elapsedMs / 1000) * ABOUT_ME_ONLINE_WALKER_SPEED_PX_PER_SECOND);
                return next > onlineWalkerViewportWidth ? -onlineWalkerWidth : next;
            });

            animationFrameId = requestAnimationFrame(animate);
        };

        animationFrameId = requestAnimationFrame(animate);

        return () =>
        {
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        };
    }, [onlineWalkerViewportWidth, onlineWalkerWidth, shouldShowOnlineWalker]);

    useEffect(() =>
    {
        if (!onlineWalkerExitToken)
        {
            return undefined;
        }

        let animationFrameId = null;
        let startTime = null;

        const animate = (timestamp) =>
        {
            if (startTime == null) startTime = timestamp;

            const elapsedMs = timestamp - startTime;
            const progress = Math.min(1, elapsedMs / ABOUT_ME_ONLINE_WALKER_EXIT_DURATION_MS);
            const liftProgress = Math.min(1, progress / 0.42);
            const fallProgress = Math.max(0, (progress - 0.42) / 0.58);

            setOnlineWalkerExitState(
            {
                active: true,
                offsetY: (-Math.sin(liftProgress * Math.PI) * ABOUT_ME_ONLINE_WALKER_EXIT_JUMP_HEIGHT) + (fallProgress * ABOUT_ME_ONLINE_WALKER_EXIT_FALL_DISTANCE),
                rotationDeg: progress * ABOUT_ME_ONLINE_WALKER_EXIT_ROTATION_DEG,
            });

            if (progress < 1)
            {
                animationFrameId = requestAnimationFrame(animate);
                return;
            }

            setOnlineWalkerExitState(
            {
                active: false,
                offsetY: 0,
                rotationDeg: 0,
            });
            setOnlineWalkerDisabled(true);
        };

        animationFrameId = requestAnimationFrame(animate);

        return () =>
        {
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        };
    }, [onlineWalkerExitToken]);

    useEffect(() =>
    {
        const onKeyDown = (event) =>
        {
            if (event.code === 'ShiftLeft') setLeftShiftHeld(true);
        };

        const onKeyUp = (event) =>
        {
            if (event.code === 'ShiftLeft') setLeftShiftHeld(false);
        };

        const onBlur = () => setLeftShiftHeld(false);

        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('keyup', onKeyUp);
        window.addEventListener('blur', onBlur);

        return () =>
        {
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('keyup', onKeyUp);
            window.removeEventListener('blur', onBlur);
        };
    }, []);

    useEffect(() =>
    {
        if (activeSectionId !== 'secret') lastNonSecretSectionRef.current = activeSectionId;
    }, [activeSectionId]);

    useEffect(() =>
    {
        if (displayedSectionId === 'offline') setOnlineWalkerDisabled(false);
    }, [displayedSectionId]);

    useEffect(() =>
    {
        if (activeSectionId !== 'secret') return;

        try
        {
            window.dispatchEvent(new CustomEvent('aboutme-secret-entered'));
        }
        catch (e)
        {}
    }, [activeSectionId]);

    useEffect(() =>
    {
        if (leftShiftHeld || activeSectionId !== 'secret') return;

        const fallbackSectionId = lastNonSecretSectionRef.current || 'general';
        setActiveSectionId(fallbackSectionId);
        setDisplayedSectionId(fallbackSectionId);
        setAudioReplayKey((value) => value + 1);
    }, [activeSectionId, leftShiftHeld]);

    const handleSectionSelect = (sectionId) =>
    {
        if (tabTransition.active || pageLeaving) return;

        const config = getTabAudioConfig(sectionId);
        const playDelayMs = Number.isFinite(Number(config.playDelayMs)) ? Math.max(0, Number(config.playDelayMs)) : 0;

        if (displayedSection.id === 'offline' && sectionId !== 'offline')
        {
            setOnlineWalkerDisabled(true);
            setOnlineWalkerExitState(
            {
                active: false,
                offsetY: 0,
                rotationDeg: 0,
            });
        }

        shouldPlaySfxOnNextBackgroundStartRef.current = false;
        stopBackgroundAudio();
        playClickSound(sectionId);

        if (sectionId === activeSectionId)
        {
            startTabTransition(playDelayMs);
            setAudioReplayKey((value) => value + 1);
            return;
        }

        startTabTransition(playDelayMs, sectionId);
        setActiveSectionId(sectionId);
    };

    const handleReturnToMain = () =>
    {
        if (tabTransition.active || pageLeaving) return;

        clearTransitionTimers();
        clearPageLeaveTimer();
        setPageLeaving(true);
        stopBackgroundAudio(ABOUT_ME_PAGE_LEAVE_MS);

        if (displayedSection.id === 'offline')
        {
            setOnlineWalkerDisabled(false);
            setOnlineWalkerExitState(
            {
                active: true,
                offsetY: 0,
                rotationDeg: 0,
            });
            setOnlineWalkerExitToken((value) => value + 1);
        }

        pageLeaveTimerRef.current = setTimeout(() =>
        {
            pageLeaveTimerRef.current = null;
            setOnlineWalkerDisabled(true);
            navigate('/main');
        }, ABOUT_ME_PAGE_LEAVE_MS);
    };

    return ( <div style = {
            {
                position: 'fixed',
                inset: 0,
                overflow: 'hidden',
                pointerEvents: pageLeaving ? 'none' : 'auto',
                zIndex: 2500,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 'clamp(14px, 2vw, 24px)',
            }
        } >
        <style >
        {
            `
        @keyframes aw24GeneralTileDrift {
          from {
            background-position: 0 0;
          }
          to {
            background-position: -${ABOUT_ME_GENERAL_TILE_SIZE}px ${ABOUT_ME_GENERAL_TILE_SIZE}px;
          }
        }

        @keyframes aw24GeneralTileMaskDrift {
          from {
            -webkit-mask-position: 0 0;
            mask-position: 0 0;
          }
          to {
            -webkit-mask-position: -${ABOUT_ME_GENERAL_TILE_SIZE}px ${ABOUT_ME_GENERAL_TILE_SIZE}px;
            mask-position: -${ABOUT_ME_GENERAL_TILE_SIZE}px ${ABOUT_ME_GENERAL_TILE_SIZE}px;
          }
        }
      `
        } </style>

        {
            displayedSection.id === 'general' && ( <div aria-hidden = "true"
                style = {
                    {
                        position: 'absolute',
                        inset: 0,
                        background: generalBackgroundTheme.baseBackground,
                        opacity: (pageLeaving || !backgroundLayersVisible) ? 0 : 1,
                        transition: `opacity ${ABOUT_ME_PAGE_LEAVE_MS}ms ease`,
                        pointerEvents: 'none',
                        zIndex: 0,
                    }
                }
                />
            )
        }

        {
            displayedSection.id === 'general' && HALLOWEEN_MODE && ( <div aria-hidden = "true"
                style = {
                    {
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: generalBackgroundTheme.tintColor,
                        WebkitMaskImage: generalBackgroundTheme.tintMaskImage,
                        maskImage: generalBackgroundTheme.tintMaskImage,
                        WebkitMaskPosition: '0 0',
                        maskPosition: '0 0',
                        WebkitMaskRepeat: 'repeat',
                        maskRepeat: 'repeat',
                        WebkitMaskSize: `${ABOUT_ME_GENERAL_TILE_SIZE}px ${ABOUT_ME_GENERAL_TILE_SIZE}px`,
                        maskSize: `${ABOUT_ME_GENERAL_TILE_SIZE}px ${ABOUT_ME_GENERAL_TILE_SIZE}px`,
                        animation: 'aw24GeneralTileMaskDrift 14s linear infinite',
                        opacity: (pageLeaving || !backgroundLayersVisible) ? 0 : 1,
                        transition: `opacity ${ABOUT_ME_PAGE_LEAVE_MS}ms ease`,
                        pointerEvents: 'none',
                        zIndex: 1,
                    }
                }
                />
            )
        }

        {
            displayedSection.id === 'general' && !HALLOWEEN_MODE && ( <div aria-hidden = "true"
                style = {
                    {
                        position: 'absolute',
                        inset: 0,
                        backgroundImage: generalBackgroundTheme.tileImage,
                        backgroundPosition: '0 0',
                        backgroundRepeat: 'repeat',
                        backgroundSize: `${ABOUT_ME_GENERAL_TILE_SIZE}px ${ABOUT_ME_GENERAL_TILE_SIZE}px`,
                        animation: 'aw24GeneralTileDrift 14s linear infinite',
                        opacity: (pageLeaving || !backgroundLayersVisible) ? 0 : 1,
                        filter: generalBackgroundTheme.tileFilter,
                        transition: `opacity ${ABOUT_ME_PAGE_LEAVE_MS}ms ease`,
                        pointerEvents: 'none',
                        zIndex: 1,
                    }
                }
                />
            )
        }

        {
            shouldShowOnlineWalker && ( <div aria-hidden = "true"
                style = {
                    {
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: onlineWalkerHeight + ABOUT_ME_ONLINE_WALKER_FLOOR_OFFSET,
                        pointerEvents: 'none',
                        overflow: onlineWalkerExitState.active ? 'visible' : 'hidden',
                        zIndex: 5,
                    }
                } >
                <div style = {
                    {
                        position: 'absolute',
                        left: onlineWalkerLeft,
                        bottom: ABOUT_ME_ONLINE_WALKER_FLOOR_OFFSET,
                        filter: 'drop-shadow(0 10px 16px rgba(0, 0, 0, 0.3))',
                        willChange: 'transform',
                        transform: onlineWalkerExitState.active ?
                            `translateY(${onlineWalkerExitState.offsetY}px) rotate(${onlineWalkerExitState.rotationDeg}deg)` :
                            'translateY(0px) rotate(0deg)',
                        transformOrigin: 'center center',
                    }
                } >
                <RGLIcon basePath = "/AboutMe Images/OnlineImages/AriWander"
                width = {
                    onlineWalkerWidth
                }
                height = {
                    onlineWalkerHeight
                }
                frameIntervalMs = {
                    ABOUT_ME_OFFLINE_WALKER_FRAME_INTERVAL_MS
                }
                syncTimeMs = {
                    getOfflineWalkerSyncTimeMs
                }
                frameIndices = {
                    onlineWalkerFrameIndices
                }
                loop = {
                    !onlineWalkerExitState.active
                }
                style = {
                    {
                        opacity: pageLeaving ? 0 : 0.96,
                        transition: `opacity ${ABOUT_ME_PAGE_LEAVE_MS}ms ease`,
                    }
                }
                /> </div> </div>
            )
        }

        <section style = {
            {
                position: 'relative',
                zIndex: 2,
                width: `${aboutMeStageWidth}px`,
                height: `${ABOUT_ME_STAGE_HEIGHT}px`,
                opacity: pageLeaving ? 0 : (visible ? 1 : 0),
                transform: (pageLeaving || visible) ?
                    `translateY(0) scale(${aboutMeStageScale})` :
                    `translateY(22px) scale(${aboutMeStageScale})`,
                transformOrigin: 'center center',
                filter: 'blur(0px)',
                transition: pageLeaving ?
                    `opacity ${ABOUT_ME_PAGE_LEAVE_MS}ms ease` :
                    'opacity 420ms ease, transform 420ms ease, filter 420ms ease',
            }
        } >
        <div style = {
            {
                display: 'grid',
                gap: 0,
                color: displayedPalette.pageText,
            }
        } >
        <div style = {
            {
                display: 'flex',
                flexWrap: 'nowrap',
                gap: ABOUT_ME_TAB_GAP,
                paddingLeft: ABOUT_ME_TAB_ROW_SIDE_PADDING,
                paddingRight: ABOUT_ME_TAB_ROW_SIDE_PADDING,
                position: 'relative',
                zIndex: 2,
            }
        } >
        {
            visibleSections.map((section, index) =>
            {
                const isActive = section.id === activeSection.id;

                return ( <button key = {
                        section.id
                    }
                    type = "button"
                    disabled = {
                        tabTransition.active || pageLeaving
                    }
                    onClick = {
                        () => handleSectionSelect(section.id)
                    }
                    aria-label = {
                        section.title
                    }
                    title = {
                        section.title
                    }
                    style = {
                        {
                            appearance: 'none',
                            border: '1px solid rgba(255,255,255,0.16)',
                            borderBottom: isActive ? `1px solid ${displayedPalette.tabActiveBorderBottom}` : '1px solid rgba(255,255,255,0.12)',
                            background: isActive ?
                                `linear-gradient(180deg, ${displayedPalette.tabActiveTop}, ${displayedPalette.tabActiveBottom})` :
                                `linear-gradient(180deg, ${displayedPalette.tabInactiveTop}, ${displayedPalette.tabInactiveBottom})`,
                            color: isActive ? displayedPalette.title : displayedPalette.summary,
                            boxSizing: 'border-box',
                            padding: 0,
                            minWidth: `${ABOUT_ME_TAB_MIN_WIDTH}px`,
                            width: `${ABOUT_ME_TAB_MIN_WIDTH}px`,
                            height: `${ABOUT_ME_TAB_HEIGHT}px`,
                            flex: `0 0 ${ABOUT_ME_TAB_MIN_WIDTH}px`,
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: (tabTransition.active || pageLeaving) ? 'default' : 'pointer',
                            boxShadow: isActive ? '0 12px 28px rgba(0,0,0,0.22)' : '0 10px 22px rgba(0,0,0,0.28)',
                            transform: isActive ? 'translateY(0)' : `translateY(${10 + (index * 2)}px)`,
                            borderRadius: 0,
                            overflow: 'visible',
                            position: 'relative',
                            zIndex: isActive ? 4 : 1,
                            transition: 'transform 220ms ease, background 220ms ease, color 220ms ease, box-shadow 220ms ease',
                        }
                    } >
                    <div style = {
                        {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%',
                            overflow: 'visible',
                            transform: 'translate(10px, -25px)',
                        }
                    } >
                    <img src = {
                        getAboutMeTabIconSource(section.id, isActive)
                    }
                    alt = {
                        section.title
                    }
                    style = {
                        {
                            display: 'block',
                            width: `${ABOUT_ME_TAB_ICON_SIZE}px`,
                            height: `${ABOUT_ME_TAB_ICON_SIZE}px`,
                            objectFit: 'contain',
                            opacity: isActive ? 1 : 0.92,
                            filter: isActive ? 'drop-shadow(0 3px 3px rgb(0, 0, 0))' : 'none',
                            userSelect: 'none',
                            pointerEvents: 'none',
                        }
                    }
                    /> </div> </button>
                );
            })
        } </div>

        <div style = {
            {
                background: `linear-gradient(135deg, ${displayedPalette.panelTop}, ${displayedPalette.panelBottom})`,
                border: '1px solid rgba(255,255,255,0.16)',
                boxShadow: '0 20px 80px rgba(0,0,0,0.45)',
                backdropFilter: 'blur(12px)',
                marginTop: -1,
                padding: '32px',
                position: 'relative',
                zIndex: 3,
                height: '620px',
                overflow: 'hidden',
                display: 'grid',
                gridTemplateRows: 'auto auto 1fr auto',
                gap: 18,
            }
        } >
        <div style = {
            {
                display: 'grid',
                gap: 12,
                textAlign: 'left'
            }
        } >
        <div style = {
            {
                fontSize: '0.9rem',
                letterSpacing: '0.28em',
                textTransform: 'uppercase',
                color: displayedPalette.accent
            }
        } >
        {
            `// AboutMe / ${displayedSectionPathLabel}`
        } </div> <div style = {
            {
                margin: 0,
                maxWidth: 860,
                fontSize: '2rem',
                lineHeight: 1.28,
                fontWeight: 700,
                color: displayedPalette.title
            }
        } >
        {
            displayedSection.summary
        } </div> </div>

        <div style = {
            {
                padding: '20px 22px 24px',
                background: displayedPalette.card,
                border: `1px solid ${displayedPalette.cardBorder}`,
                textAlign: 'left',
                display: 'grid',
                alignContent: 'start',
                gap: 14,
                minHeight: 0,
            }
        } >
        <div style = {
            {
                fontSize: '1.4rem',
                fontWeight: 700,
                color: displayedPalette.title
            }
        } >
        {
            displayedSection.title
        } </div>
        {
            displayedSection.details.filter((detail) => detail && detail.trim()).map((detail, index) => ( <p key = {
                    `${displayedSection.id}-detail-${index}`
                }
                style = {
                    {
                        margin: 0,
                        maxWidth: 760,
                        color: displayedPalette.summary,
                        lineHeight: 1.5
                    }
                } >
                {
                    detail
                } </p>
            ))
        } </div>

        <div style = {
            {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'end',
                paddingTop: 4,
                position: 'relative',
                zIndex: 3
            }
        } >
        <button type = "button"
        className = "btn-primary btn-danger"
        onClick = {
            handleReturnToMain
        }
        disabled = {
            tabTransition.active || pageLeaving
        } >
        Return to /main </button> </div> </div> </div> </section>

        {
            tabTransition.active && ( <div style = {
                    {
                        position: 'fixed',
                        inset: 0,
                        pointerEvents: 'none',
                        zIndex: 7000,
                        overflow: 'hidden'
                    }
                }
                aria-hidden = "true" >
                <div style = {
                    {
                        position: 'absolute',
                        inset: 0,
                        background: `radial-gradient(circle at center, ${transitionPalette.overlayInner} 0%, ${transitionPalette.overlayMid} 55%, ${transitionPalette.overlayOuter} 100%)`,
                        clipPath: `circle(${tabTransition.radiusVmax}vmax at 50% 50%)`,
                        opacity: tabTransition.opacity,
                        transition: `clip-path ${tabTransition.closeDurationMs}ms cubic-bezier(.18,.74,.14,1), opacity ${tabTransition.durationMs}ms ease-out`,
                        willChange: 'clip-path, opacity',
                    }
                }
                />

                {
                    tabTransition.imageSrc && ( <img src = {
                            tabTransition.imageSrc
                        }
                        alt = ""
                        draggable = {
                            false
                        }
                        style = {
                            {
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                width: tabTransition.imageWidth,
                                maxWidth: '86vw',
                                height: 'auto',
                                transform: `translate(-50%, -50%) rotate(${tabTransition.imageRotateDeg}deg) scale(${tabTransition.imageScale})`,
                                transformOrigin: 'center center',
                                opacity: tabTransition.imageOpacity,
                                transition: `transform ${tabTransition.closeDurationMs}ms cubic-bezier(.08,.86,.18,1), opacity ${tabTransition.durationMs}ms ease-out`,
                                willChange: 'transform, opacity',
                                filter: 'drop-shadow(0 16px 40px rgba(0,0,0,0.38))',
                                zIndex: 2,
                                pointerEvents: 'none',
                                userSelect: 'none',
                            }
                        }
                        />
                    )
                } </div>
            )
        } </div>
    );
}
